<div class="seg seg-detalle">
  <app-breadcrumb
    listado="/main/luminarias/seguimiento/encendidos"
    etiquetaListado="Seguimiento"
    [titulo]="titulo()"
  ></app-breadcrumb>

  <div class="seg-cabecera">
    <div class="seg-cabecera__identidad">
      <h1>
        <mat-icon>
          {{ campana()?.nombre === 'Apagar' ? 'light_off' : 'lightbulb' }}
        </mat-icon>
        {{ titulo() ?? 'Encendido o apagado' }}
      </h1>
      @if (campana(); as c) {
        <p class="seg-bajada">
          @if (estado(); as e) {
            <span class="seg-chip" [style.--tono]="e.tono">
              <mat-icon>{{ e.icono }}</mat-icon>
              {{ e.titulo }}
            </span>
          }
          @if (objetivo(); as o) {
            <span>{{ o }}</span>
            <span>·</span>
          }
          <span>
            {{ c.nodos | number }}
            {{ c.nodos === 1 ? 'luminaria' : 'luminarias' }}
          </span>
          <span>·</span>
          <span class="seg-origen" [matTooltip]="c.explicacionOrigen">
            <mat-icon>{{ iconoOrigen() }}</mat-icon>
            {{ c.origen }}
          </span>
        </p>
      }
    </div>
    <div class="seg-cabecera__acciones">
      <button
        irxBoton="secundario"
        type="button"
        (click)="recargar()"
        [disabled]="jobs.isLoading()"
      >
        <mat-icon>refresh</mat-icon>
        Actualizar
      </button>
    </div>
  </div>

  <div class="seg-contenido">
    @if (jobs.isLoading() && !jobs.hasValue()) {
      <div class="seg-vacio" role="status">
        <mat-icon>hourglass_empty</mat-icon>
        <p>Buscando los envíos…</p>
      </div>
    } @else if (jobs.error()) {
      <div class="seg-vacio seg-vacio--error" role="alert">
        <mat-icon>error_outline</mat-icon>
        <p>No se pudieron traer los envíos.</p>
      </div>
    } @else if (!campana()) {
      <div class="seg-vacio">
        <mat-icon>search_off</mat-icon>
        <p><strong>No hay envíos con este identificador</strong></p>
        <p>
          Los encendidos y apagados viejos se pierden de vista cuando sus envíos
          salen de la ventana que se consulta.
        </p>
      </div>
    } @else if (campana(); as c) {
      <div class="seg-portada">
        <!-- Estado: el avance, con su desglose por nodos. -->
        <section class="seg-tarjeta seg-estado" [style.--tono]="estado()?.tono">
          <div class="seg-estado__cabeza">
            <span class="seg-estado__icono">
              <mat-icon>{{ estado()?.icono }}</mat-icon>
            </span>
            <div>
              <span class="seg-sobretitulo">{{ estado()?.titulo }}</span>
              <h2
                matTooltip="Sobre los nodos que aplicaron la configuración. Un nodo que cerró descartado no recibió nada, y uno que confirmó y no aplicó tampoco."
              >
                {{ porcentaje() }} % aplicado
              </h2>
              <p class="seg-estado__motivo">
                {{ c.nodosConvergidos | number }} de {{ c.nodos | number }}
                {{
                  c.nodos === 1 ? 'luminaria aplicó' : 'luminarias aplicaron'
                }}
                @if (!c.terminada) {
                  · {{ c.nodosCerrados | number }} ya no esperan nada
                }
              </p>
            </div>
          </div>

          <div
            class="seg-barra-avance seg-barra-avance--grande"
            role="img"
            [attr.aria-label]="porcentaje() + ' por ciento aplicado'"
          >
            @for (s of segmentos(); track s.clave) {
              <span
                [style.width.%]="s.ancho"
                [style.background]="s.tono"
              ></span>
            }
          </div>
          <ul class="seg-leyenda">
            @for (s of segmentos(); track s.clave) {
              <li>
                <span class="seg-punto" [style.background]="s.tono"></span>
                <strong>{{ s.valor | number }}</strong>
                {{ s.etiqueta }}
              </li>
            }
          </ul>

          <dl class="seg-kpis-mini">
            <div class="seg-kpi" matTooltip="Cuándo salió el primer envío.">
              <dt>
                <mat-icon>play_arrow</mat-icon>
                Arrancó
              </dt>
              <dd>{{ fecha(c.inicio) }}</dd>
              <span class="seg-hace">{{ cuando(c.inicio) }}</span>
            </div>
            <div
              class="seg-kpi"
              matTooltip="La última confirmación, veredicto o envío del lote."
            >
              <dt>
                <mat-icon>update</mat-icon>
                Última novedad
              </dt>
              <dd>{{ fecha(c.ultimaNovedad) }}</dd>
              <span class="seg-hace">{{ cuando(c.ultimaNovedad) }}</span>
            </div>
            <div
              class="seg-kpi"
              [matTooltip]="
                c.terminada
                  ? 'Desde el primer envío hasta la última novedad.'
                  : 'Desde el primer envío hasta ahora.'
              "
            >
              <dt>
                <mat-icon>timer</mat-icon>
                {{ c.terminada ? 'Duró' : 'Lleva' }}
              </dt>
              @if (lleva(); as l) {
                <dd>{{ l }}</dd>
              } @else {
                <dd class="no-info">Sin dato</dd>
              }
            </div>
            <div
              class="seg-kpi"
              [class.seg-kpi--destacado]="d()?.aRevisar"
              matTooltip="Nodos que confirmaron y no aplicaron, agotaron los envíos sin dar señal, fallaron o se les abortó el envío. Piden que alguien mire el nodo."
            >
              <dt>
                <mat-icon>flag</mat-icon>
                A revisar
              </dt>
              <dd>{{ d()?.aRevisar ?? 0 | number }}</dd>
            </div>
            <div
              class="seg-kpi"
              matTooltip="No se les mandó nada porque estaban fuera de línea: pasaron su tiempo límite de comunicación (24 h si no tienen uno). Ya están avisados por el evento de comunicación."
            >
              <dt>
                <mat-icon>cloud_off</mat-icon>
                Sin comunicación
              </dt>
              <dd>{{ d()?.sinComunicacion ?? 0 | number }}</dd>
            </div>
            @if (falta(); as f) {
              <div
                class="seg-kpi"
                matTooltip="Regla de tres sobre el ritmo que lleva. No es una promesa: si los que faltan son los que no comunican, no cierra nunca."
              >
                <dt>
                  <mat-icon>hourglass_top</mat-icon>
                  Faltarían
                </dt>
                <dd>{{ f }}</dd>
              </div>
            } @else {
              <div
                class="seg-kpi"
                matTooltip="Un nodo puede tener varios envíos en su plan."
              >
                <dt>
                  <mat-icon>outbox</mat-icon>
                  Envíos
                </dt>
                <dd>{{ c.pasos | number }}</dd>
              </div>
            }
          </dl>
        </section>

        <!-- Los envíos por estado: son pasos, no nodos. -->
        <section class="seg-tarjeta">
          <header class="seg-tarjeta__titulo">
            <mat-icon>outbox</mat-icon>
            <h2>Los envíos, por estado</h2>
            <span class="seg-tarjeta__extremo">
              {{ c.pasos | number }} {{ c.pasos === 1 ? 'envío' : 'envíos' }}
            </span>
          </header>
          <p class="seg-nota">
            Cuentan
            <strong>envíos</strong>
            y no nodos: el plan de un nodo puede tener varios.
          </p>
          <ul class="seg-estados">
            @for (e of estados(); track e.estado) {
              <li [style.--tono]="e.color" [matTooltip]="e.detalle">
                <div class="seg-estados__fila">
                  <mat-icon>{{ e.icono }}</mat-icon>
                  <span class="seg-estados__nombre">{{ e.etiqueta }}</span>
                  <strong>{{ e.cuantos | number }}</strong>
                </div>
                <div class="seg-estados__barra">
                  <span [style.width.%]="e.ancho"></span>
                </div>
              </li>
            }
          </ul>
        </section>
      </div>

      <!-- Los que quedaron atrás. -->
      <section class="seg-tarjeta">
        <header class="seg-tarjeta__titulo">
          <mat-icon
            [style.color]="
              !c.rezagados.length
                ? 'var(--color-green-icon)'
                : d()?.aRevisar
                  ? 'var(--color-orange-icon)'
                  : null
            "
          >
            {{ c.rezagados.length ? 'flag' : 'task_alt' }}
          </mat-icon>
          <h2>Los que quedaron atrás</h2>
          @if (c.rezagados.length) {
            <span class="seg-cuenta">{{ c.rezagados.length | number }}</span>
          }
        </header>

        @if (!c.rezagados.length) {
          <p class="seg-vacio-linea">
            <mat-icon class="seg-ok">check_circle</mat-icon>
            Ninguno: todos los nodos cerraron bien.
          </p>
        } @else {
          <div class="seg-motivos" role="group" aria-label="Filtrar por motivo">
            @for (m of porMotivo(); track m.motivo) {
              <button
                type="button"
                class="irx-chip seg-motivo"
                [style.--tono]="m.tono"
                [attr.aria-pressed]="motivoFiltro() === m.motivo"
                [tooltip]="m.detalle"
                (click)="alternarMotivo(m.motivo)"
              >
                <mat-icon>{{ m.icono }}</mat-icon>
                <strong>{{ m.cuantos | number }}</strong>
                <span>{{ m.etiqueta }}</span>
              </button>
            }
          </div>

          @if (sinComunicacionOcultos()) {
            <p class="seg-pista-sin">
              <mat-icon>cloud_off</mat-icon>
              <span>
                {{ sinComunicacionOcultos() | number }}
                @if (sinComunicacionOcultos() === 1) {
                  nodo no comunicaba y no está en la tabla: no se le mandó nada
                  y ya tiene su evento de comunicación.
                } @else {
                  nodos no comunicaban y no están en la tabla: no se les mandó
                  nada y ya tienen su evento de comunicación.
                }
              </span>
              <button
                irxBoton="texto"
                type="button"
                (click)="verSinComunicacion.set(true)"
              >
                Mostrarlos
              </button>
            </p>
          } @else if (
            verSinComunicacion() && !motivoFiltro() && d()?.sinComunicacion
          ) {
            <p class="seg-pista-sin">
              <button
                irxBoton="texto"
                type="button"
                (click)="verSinComunicacion.set(false)"
              >
                Ocultar los que no comunicaban
              </button>
            </p>
          }

          @if (rezagadosVisibles().length) {
            <div class="seg-tabla-scroll">
              <table class="seg-tabla">
                <thead>
                  <tr>
                    <th scope="col">Nodo</th>
                    <th scope="col">Por qué</th>
                    <th scope="col" class="seg-numero">Pasos</th>
                    <th scope="col" class="seg-numero">Envíos</th>
                    <th scope="col">Detalle</th>
                  </tr>
                </thead>
                <tbody>
                  @for (r of rezagadosVisibles(); track r.deveui) {
                    <tr>
                      <th scope="row" class="seg-mono">
                        @if (r.idDispositivo && verNodos) {
                          <a
                            class="irx-enlace"
                            [routerLink]="[
                              '/main/administracion/dispositivoslorawan/detalles',
                              r.idDispositivo,
                            ]"
                          >
                            {{ r.deveui }}
                          </a>
                        } @else {
                          {{ r.deveui }}
                        }
                      </th>
                      <td>
                        <span
                          class="seg-chip"
                          [style.--tono]="tono(r.motivo)"
                          [matTooltip]="MOTIVOS[r.motivo].detalle"
                        >
                          <mat-icon>{{ MOTIVOS[r.motivo].icono }}</mat-icon>
                          {{ MOTIVOS[r.motivo].etiqueta }}
                        </span>
                      </td>
                      <td class="seg-numero">{{ r.pasos }}</td>
                      <td class="seg-numero">{{ r.intentos }}</td>
                      <td class="seg-detalle-texto">
                        @if (r.detalle) {
                          {{ r.detalle }}
                        } @else {
                          <span class="no-info">Sin detalle</span>
                        }
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          } @else {
            <p class="seg-vacio-linea">
              <mat-icon class="seg-ok">check_circle</mat-icon>
              Nada que revisar: los que quedan atrás son nodos sin comunicación.
            </p>
          }

          @if (cuantosFiltrados() > rezagadosVisibles().length) {
            <p class="seg-nota">
              Se listan {{ rezagadosVisibles().length | number }} de
              {{ cuantosFiltrados() | number }}. Filtrá por motivo para ver el
              resto.
            </p>
          }
        }
      </section>
    }
  </div>
</div>
